import styled from "styled-components";
import { usePlatform, } from "@bracket/platform/store";
import {  Stream, Text as Tx, Loader, Box, } from "@bracket/ui";

import type { FunctionComponent, } from "react";

export const BrktTVL: FunctionComponent = () => {

	const { brkt_tvl, ready, } = usePlatform();
	const isZero = brkt_tvl.asset.isZero();


	return (
		<Box>
			<Paragraph>
				<Tx h6 color="subheading">BrktETH TVL:</Tx>
				<TVLValueStack>
					{ ready &&  isZero && <Tx h6 size="md" color="heading">0.00 brktETH</Tx> }
					{ ready && !isZero && <Tx h6 size="md" color="heading">{brkt_tvl.usd.toLocaleString('en-US', { style: "currency", currency: "USD", })}</Tx> }
					{ ready && !isZero && <Tx>/</Tx> }
					{ ready && !isZero && <Tx size="xsm" lineHeight="1.5rem" style={{ alignSelf: "flex-end", marginBottom: "0.05rem", }}>{brkt_tvl.asset.toDecimalString(2)} brktETH</Tx> }
				</TVLValueStack>
				{ !ready && <Loader scheme="light" center small /> }
			</Paragraph>
		</Box>
	)
}

export const Paragraph = ({ children, }: { children: React.ReactNode }) => {

	return (
		<ParagraphRoot>
			{children}
		</ParagraphRoot>
	)
}


const TVLValueStack = styled(Stream)`
	align-items: center;
	justify-content: center;
	gap: 0.25rem;
	margin-left: 0.5rem;
`;

const ParagraphRoot = styled.div`
	display: inline-flex;
	scale: 0.85;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;
